import Dialog, { DialogContent } from '@/components/Dialog';
import { SHARE_MODAL_TYPES } from '@/store/editor';

import PasswordModal from '../PasswordModal';
import PrintDocumentContent from './PrintDocumentContent';
import ShareCopyLink from './ShareCopyLink';
import ShareSendByEmail from './ShareSendByEmail';
import { usePrintModal } from './hooks';

function ShareDocumentModal({
	defaultFileName,
	id,
	open,
	onOpenChange,
	type,
	publicId
}) {
	const { passwordModalProps, ...printModalProps } = usePrintModal({
		onOpenChange,
		open: open && type === SHARE_MODAL_TYPES.PRINT,
		id
	});
	const isPrintModal = type === SHARE_MODAL_TYPES.PRINT;

	const content = (
		<>
			{type === SHARE_MODAL_TYPES.COPY_LINK && (
				<ShareCopyLink id={publicId} onOpenChange={onOpenChange} />
			)}
			{type === SHARE_MODAL_TYPES.PRINT && (
				<PrintDocumentContent {...printModalProps} />
			)}
			{type === SHARE_MODAL_TYPES.SEND_BY_EMAIL && (
				<ShareSendByEmail
					defaultFileName={defaultFileName}
					id={id}
					onOpenChange={onOpenChange}
					open={open}
				/>
			)}
		</>
	);

	return (
		<>
			<PasswordModal {...passwordModalProps} />
			<Dialog
				open={open && !passwordModalProps.open}
				onOpenChange={
					isPrintModal ? printModalProps.onOpenChange : onOpenChange
				}
			>
				<DialogContent className="w-[280px] md:w-[397px]">
					{content}
				</DialogContent>
			</Dialog>
		</>
	);
}

export default ShareDocumentModal;
